<template>
  <b-form-radio-group
    id="custom_variable_value"
    v-model="selectModel"
    :options="radioOptions"
    value-field="item"
    text-field="name"
    disabled-field="notEnabled"
    data-id="custom_variable_value"
    data-fieldtype="radio"
    class="demo-inline-spacing form-group"
  />
</template>

<script>
// import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BFormRadioGroup,
} from 'bootstrap-vue'

export default {
  components: {
    BFormRadioGroup,
  },
  props: {
    selectModel: {
      type: [String, Number],
      required: true,
      default: '',
    },
  },
  data() {
    return {
      radioOptions: [
        { item: 'true', name: 'True' },
        { item: 'false', name: 'False' },
      ],
    }
  },
  watch: {
  },
  created() {
  },
  methods: {
  },
}
</script>

          <style lang="scss">
          </style>
